import { JsonEditorSchema } from "@/shared/JsonEditorSchema/models/JsonEditorSchema";
import { JsonEditorType } from "@/shared/JsonEditorSchema/models/JsonEditorType";
import SchemaGenerator from "./SchemaGenerator";
import { AnalysisConfigFieldType } from "@/components/AnalysisConfig/models/AnalysisConfigFieldType";
import { AnalysisConfig } from "@/components/AnalysisConfig/models/AnalysisConfig";


export class AnalysisConfigSchemaGenerator extends SchemaGenerator<AnalysisConfig> {

    public createRootSchema(): JsonEditorSchema<AnalysisConfig> {

        const rootSchema: JsonEditorSchema<AnalysisConfig> = {
            type: 'object',
            properties: {
                type: { type: 'string' },
                description: { type: 'string' }
            },
            required: ['type']
        };

        return rootSchema;
    }

    public mapType(fieldType: any): JsonEditorType | null {
        switch (fieldType) {
            case AnalysisConfigFieldType.Text:
            case AnalysisConfigFieldType.Select:
            case AnalysisConfigFieldType.SelectOrCreate:
            case AnalysisConfigFieldType.ColumnSelectOrCreate:
            case AnalysisConfigFieldType.ColumnSelect:
            case AnalysisConfigFieldType.SelectJson:
            case AnalysisConfigFieldType.ColorPicker:
            case AnalysisConfigFieldType.StringTemplate:
            case AnalysisConfigFieldType.RegularExpression:
            case AnalysisConfigFieldType.SelectXorText:
            case AnalysisConfigFieldType.SelectXorSelect:
            case AnalysisConfigFieldType.TextXorSelect:
                return 'string';
            case AnalysisConfigFieldType.Number:
                return 'number';
            case AnalysisConfigFieldType.Boolean:
                return 'boolean';
            case AnalysisConfigFieldType.Array:
            case AnalysisConfigFieldType.ArrayValues:
            case AnalysisConfigFieldType.MultiSelect:
            case AnalysisConfigFieldType.ColumnMultiSelect:
            case AnalysisConfigFieldType.ColumnMultiSelectOrCreate:
                return 'array';
            case AnalysisConfigFieldType.Object:
            case AnalysisConfigFieldType.Json:
                return 'object';
            default:
                return null;
        }
    }

    //@ts-ignore
    public populateVariants(schema: JsonEditorSchema<AnalysisConfig>, variants: Array<any>, options: any): void {

        schema.unevaluatedProperties = false;

        // Merge property KEY stubs only (empty = accept-all at root level)
        // This marks them as "evaluated" for unevaluatedProperties without
        // performing type validation at the root, avoiding duplicate errors
        for (const variant of variants) {
            const { type: _t, ...otherProps } = variant.properties;
            for (const key of Object.keys(otherProps)) {
                if (!(schema.properties as any)[key]) {
                    (schema.properties as any)[key] = {};  // stub only, not the full schema
                }
            }
        }

        schema.allOf = variants.map((variant: any) => {
            const { type: _t, ...otherProps } = variant.properties;
            const typeValue = variant.properties.type?.enum?.[0];
            return {
                if: {
                    properties: { type: { const: typeValue } },
                    required: ['type']
                },
                then: {
                    properties: otherProps,
                    ...(variant.required?.length > 1
                        ? { required: variant.required }
                        : {})
                }
            };
        });

    }
}

export default AnalysisConfigSchemaGenerator;
